import {
  CHANGE_REFRESH,
  DUTYRANGE,
  DUTYRANGECHANGE,
  SIGNDATACHANGE,
  TagDATACHANGE,
  DUTYRANGECHANGEFORPLOBLEM,
  DUTYRANGECHANGEFORPLOBLEMRESET,
  DUTYWORKING,
  DUTYARRANGEFORPROBLEM,
  DUTYNORMALFORPROBLEM,
  DUTYUNNORMALFORPROBLEM,
  SIGNDATAFORPROBLEMFORCHANGE,
  SIGNINSYMBOLFORPROBLEM,
  unKnowStatus,
  CHANGE_SCROLLER_HEIGHT,
  SET_ROUTER,
  SET_HIGH_LIGHT_INFO,
  CHANGE_RELATEDSTATUS,
  CHANGE_DETAIL,
  INTERFACE_MODEL_STATUS,
  INTERFACE_MODEL_DATA,
  CHANGE_VMRETURNTOCHECK,
  CHANGE_NETWORKRETURNTOCHECK,
  CHANGE_SLBRETURNTOCHECK,
  CHANGE_ADDRESSRETURNTOCHECK,
  // CHANGE_INTENSIVESLBRETURNTOCHECK,
  // CHANGE_INTENSIVEADDRESSRETURNTOCHECK,
  CHANGE_INTENSIVEWEBSITEACCOUNTRETURNTOCHECK,
  CHANGE_PMRETURNTOCHECK,
  CHANGE_PMDELRETURNTOCHECK,
  CHANGE_ORACLERETURNTOCHECK,
  CHANGE_DATA_RETURN,
  RESET_DATA_RETURN,
  CHANGE_RESOURCE_SHARE_ZONE_SRATUS,
  CHANGE_PUBLIC_SERVICE_ZONE_STATUS,
  CLEAR_RESOURCE_SHARE_ZONE_SRATUS,
  CLEAR_PUBLIC_SERVICE_ZONE_STATUS,
  CHANGE_OPERATION_RES_INFO,
  CHANGE_ALL_SELECT_ARR,
  CHANGE_DELIVER_SUB_DATA,
  CHANGE_DELIVER_DATA,
  RESTART_INIT,
  CHANGE_EVENT_TAB_NAME,
  CHANGE_EVENT_PAGE,
  CHANGE_BACKFILL_LIST,
  CHANGE_HEADER_REFRESH,
  CHANGE_HEADER_USERINFO,
  CHANGE_FULL_SCREEN
} from './mutation-types'

export default {
  [CHANGE_REFRESH] (state) {
    state.status = false
  },
  [DUTYRANGE] (state) {
    state.dutyRangeStatus++
  },
  [DUTYRANGECHANGE] (state, value) {
    state.calChange = value
  },
  [SIGNDATACHANGE] (state, value) {
    state.signData = value
  },
  [TagDATACHANGE] (state, value) {
    state.tagData = value
  },
  [DUTYRANGECHANGEFORPLOBLEM] (state, value) {
    state.calChangeForProblem = value
  },
  [DUTYRANGECHANGEFORPLOBLEMRESET] (state) {
    state.calChangeForProblem = {}
  },
  [DUTYWORKING] (state, value) {
    state.workIng = value
  },
  [DUTYARRANGEFORPROBLEM] (state, value) {
    state.dutyArrangeForProblem = value
  },
  [DUTYNORMALFORPROBLEM] (state, value) {
    state.dutyNormalForProblem = value
  },
  [DUTYUNNORMALFORPROBLEM] (state, value) {
    state.dutyUnNormalForProblem = value
  },
  [SIGNDATAFORPROBLEMFORCHANGE] (state, value) {
    state.signDataForProblem = value
    // console.log(state.signDataForProblem)
  },
  [SIGNINSYMBOLFORPROBLEM] (state) {
    state.signInSymbol++
  },
  [unKnowStatus] (state, value) {
    state.unKnowWorkStatus = value
  },
  [CHANGE_SCROLLER_HEIGHT] (state, value) {
    state.scrollerHeight = value
  },
  [SET_ROUTER] (state, value) {
    state.router = value
  },
  [SET_HIGH_LIGHT_INFO] (state, value) {
    state.highLightInfo = value
  },
  [CHANGE_RELATEDSTATUS] (state, value) {
    state.isOrNotRelated = value
  },
  [CHANGE_DETAIL] (state, value) {
    state.detailArr = value
  },
  [INTERFACE_MODEL_STATUS] (state, value) {
    state.modalShow = value
  },
  [INTERFACE_MODEL_DATA] (state, value) {
    state.interfaceData = value
  },
  [CHANGE_VMRETURNTOCHECK] (state, value) {
    state.vmReturnToCheck = value
  },
  [CHANGE_SLBRETURNTOCHECK] (state, value) {
    state.slbReturnToCheck = value
  },
  [CHANGE_ADDRESSRETURNTOCHECK] (state, value) {
    state.addressReturnToCheck = value
  },
  [CHANGE_NETWORKRETURNTOCHECK] (state, value) {
    state.netReturnToCheck = value
  },
  [CHANGE_INTENSIVEWEBSITEACCOUNTRETURNTOCHECK] (state, value) {
    state.intensiveWebsiteAccountReturnToCheck = value
  },
  // [CHANGE_INTENSIVESLBRETURNTOCHECK] (state, value) {
  //   state.intensiveSLBReturnToCheck = value
  // },
  // [CHANGE_INTENSIVEADDRESSRETURNTOCHECK] (state, value) {
  //   state.intensiveAddressReturnToCheck = value
  // },
  [CHANGE_PMRETURNTOCHECK] (state, value) {
    state.pmReturnToCheck = value
  },
  [CHANGE_PMDELRETURNTOCHECK] (state, value) {
    state.pmDelReturnToCheck = value
  },
  [CHANGE_ORACLERETURNTOCHECK] (state, value) {
    state.oracleReturnToCheck = value
  },
  SUBTABLE_SELECTED_ITEM (state, value) {
    state.subTableSelectedItemList = value
  },
  [CHANGE_DATA_RETURN] (state, value) {
    state.dataReturn.push(value)
  },
  [RESET_DATA_RETURN] (state) {
    state.dataReturn = []
  },
  [CHANGE_RESOURCE_SHARE_ZONE_SRATUS] (state, value) {
    state.resourceShareZoneStatus = value
  },
  [CHANGE_PUBLIC_SERVICE_ZONE_STATUS] (state, value) {
    state.publicServiceZoneStatus = value
  },
  [CLEAR_RESOURCE_SHARE_ZONE_SRATUS] (state) {
    state.resourceShareZoneStatus.clear()
  },
  [CLEAR_PUBLIC_SERVICE_ZONE_STATUS] (state) {
    state.publicServiceZoneStatus.clear()
  },
  [CHANGE_OPERATION_RES_INFO] (state, value) {
    state.operationResourceList = value
  },
  [CHANGE_ALL_SELECT_ARR] (state, value) {
    state.allSelectArr = value
  },
  [CHANGE_DELIVER_SUB_DATA] (state, value) {
    state.deliverSubData.propRegistrationData = value.propRegistrationData
    state.deliverSubData.infomationItemsTemp = value.infomationItemsTemp
  },
  [CHANGE_DELIVER_DATA] (state, value) {
    state.deliverData = value
  },
  [RESTART_INIT] (state, value) {
    state.refresh = value
  },
  [CHANGE_EVENT_TAB_NAME] (state, value) {
    state.eventTabName = value
  },
  [CHANGE_EVENT_PAGE] (state, value) {
    state.eventPage = value
  },
  [CHANGE_BACKFILL_LIST] (state, value) {
    state.backFillList = value
  },
  [CHANGE_HEADER_REFRESH] (state, value) {
    state.headerRefresh = value
  },
  [CHANGE_HEADER_USERINFO] (state, value) {
    state.headerUserInfo = value
  },
  [CHANGE_FULL_SCREEN] (state, value) {
    state.fullScreen = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js